import { AppConfig, CbwsRequest, Mapper, SearchFlightsForm } from "../../types";
import { format } from "date-fns";
import { ConfigSliceState } from "../config/ConfigSlice";

interface getAirportMarkersProps {
  config: ConfigSliceState;
  form: SearchFlightsForm;
}

interface getStartupMarkersProps {
  appConfig: AppConfig;
  mapper: Mapper;
  cbwsRequest: CbwsRequest;
  departingDate: number;
  returningDate: number;
  startAirport: string;
  isDirectMarkers: boolean;
}

export function getAirportMarkers({ config, form }: getAirportMarkersProps) {
  const directRequest: CbwsRequest = { ...config.cbwsRequest };
  let connectionRequest: CbwsRequest | null = null;

  directRequest.originCriteria = form.originAirport.port.code;
  directRequest.requestType = "outbound";
  directRequest.requestTime = form.departingTime + ":00";
  directRequest.rtnRequestTime = form.returningTime + ":00";
  directRequest.requestDate = format(form.departingDate, "yyyy-MM-dd");
  directRequest.rtnRequestDate = format(form.returningDate, "yyyy-MM-dd");
  directRequest.requestDateEffectiveFrom = format(
    form.departingDate,
    "yyyy-MM-dd"
  );
  directRequest.requestDateEffectiveTo = format(
    form.returningDate,
    "yyyy-MM-dd"
  );
  directRequest.includeCodeShare = form.includeCodeShare;

  if (config.mapper.intialiseStartUpPoints.connections) {
    connectionRequest = { ...directRequest };
    connectionRequest.originCriteria = form.originAirport.port.code;
    connectionRequest.maxSinglesRoute = 5000;
    connectionRequest.logicalPathOnly = "D";
    if (connectionRequest.includeCodeShare === false) {
      connectionRequest.operatingCarrierOnly = true;
    }
    if (config.app.customerType.airline) {
      connectionRequest.carrier2Criteria = connectionRequest.carrier1Criteria;
      connectionRequest.carrier3Criteria = connectionRequest.carrier1Criteria;
      connectionRequest.logicalPathOnly = "L";
      connectionRequest.requestDateEffectiveTo =
        connectionRequest.requestDateEffectiveFrom;
      connectionRequest.requestDateEffectiveFrom = null;
      connectionRequest.rtnRequestDate = null;
      connectionRequest.operatingCarrierOnly = true;
    }
  }

  if (config.mapper.intialiseStartUpPoints.daysToLookForward) {
    const forwardDate = new Date(form.departingDate);
    forwardDate.setDate(
      forwardDate.getDate() +
        config.mapper.intialiseStartUpPoints.daysToLookForward
    );
    directRequest.requestDateEffectiveTo = format(forwardDate, "yyyy-MM-dd");
    if (connectionRequest != null) {
      connectionRequest.requestDateEffectiveTo = format(
        forwardDate,
        "yyyy-MM-dd"
      );
    }
  }
  if (config.app.customerType.airline) {
    directRequest.logicalPathOnly = "O";
    directRequest.requestDateEffectiveFrom = null;
    directRequest.rtnRequestDate = null;
  } else if (config.mapper.nonStopDirectMap) {
    directRequest.nonStopDirect = true;
    directRequest.numberOfStops = 0;
    directRequest.logicalPathOnly = null;
  } else {
    directRequest.logicalPathOnly = "D";
  }

  if (config.mapper.intialiseStartUpPoints.connections) {
    return {
      directMarkersAirport: {
        url: config.app.urls.directMarkersAirport,
        request: directRequest,
      },
      connectionMarkersAirport: {
        url: config.app.urls.connectionMarkersAirport,
        request: connectionRequest,
      },
    };
  }
  return {
    directMarkersAirport: {
      url: config.app.urls.directMarkersAirport,
      request: directRequest,
    },
  };
}

export function getStartUpMarkers({
  appConfig,
  mapper,
  cbwsRequest,
  departingDate,
  returningDate,
  startAirport,
  isDirectMarkers,
}: getStartupMarkersProps) {
  const directRequest: CbwsRequest = { ...cbwsRequest };
  let connectionRequest: CbwsRequest | null = null;

  directRequest.requestType = "outbound";
  directRequest.requestTime = "00:01:00";
  directRequest.rtnRequestTime = "00:01:00";
  directRequest.requestDate = format(departingDate, "yyyy-MM-dd");
  directRequest.rtnRequestDate = format(returningDate, "yyyy-MM-dd");
  directRequest.requestDateEffectiveFrom = format(departingDate, "yyyy-MM-dd");
  directRequest.requestDateEffectiveTo = format(returningDate, "yyyy-MM-dd");

  if (
    (appConfig.customerType.airport || appConfig.customerType.airline) &&
    mapper.intialiseStartUpPoints.connections
  ) {
    connectionRequest = { ...directRequest };
    connectionRequest.maxSinglesRoute = 5000;
    connectionRequest.logicalPathOnly = "D";
  }

  if (mapper.intialiseStartUpPoints.daysToLookForward) {
    const forwardDate = new Date(departingDate);
    forwardDate.setDate(
      forwardDate.getDate() + mapper.intialiseStartUpPoints.daysToLookForward
    );
    directRequest.requestDateEffectiveTo = format(forwardDate, "yyyy-MM-dd");
    if (connectionRequest != null) {
      connectionRequest.requestDateEffectiveTo = format(
        forwardDate,
        "yyyy-MM-dd"
      );
    }
  }

  if (startAirport) {
    directRequest.originCriteria = startAirport;
    if (connectionRequest != null) {
      connectionRequest.originCriteria = startAirport;
    }
  }

  if (appConfig.customerType.airline && isDirectMarkers) {
    directRequest.logicalPathOnly = "O";
    directRequest.originCriteria = "***";
    directRequest.originCriteriaLocationType = "A";
    directRequest.destinationCriteria = "***";
    directRequest.destinationCriteriaLocationType = "A";
    return {
      directMarkers: {
        url: appConfig.urls.directMarkers,
        request: directRequest,
      },
    };
  } else {
    // if (config.app.customerType.airline) {
    //   directRequest.logicalPathOnly = "L";
    //   directRequest.requestDateEffectiveFrom = null;
    //   directRequest.rtnRequestDate = null;
    // } else
    if (mapper.nonStopDirectMap) {
      directRequest.nonStopDirect = true;
      directRequest.numberOfStops = 0;
      directRequest.logicalPathOnly = null;
    } else {
      directRequest.logicalPathOnly = "D";
    }

    if (
      mapper.intialiseStartUpPoints.connections ||
      (appConfig.customerType.airline && !isDirectMarkers)
    ) {
      return {
        directMarkersAirport: {
          url: appConfig.urls.directMarkersAirport,
          request: directRequest,
        },
        connectionMarkersAirport: {
          url: appConfig.urls.connectionMarkersAirport,
          request: connectionRequest,
        },
      };
    }
    return {
      directMarkersAirport: {
        url: appConfig.urls.directMarkersAirport,
        request: directRequest,
      },
    };
  }
}
